import { Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ContactInfo } from "../../AtomicDesign/Molecules";
import Nuvens from "../../../assets/images/coelho/imagem  nuvens.png";
import useAuth from "../../../hooks/context/useAuth";
import { useEffect } from "react";
import { HeaderAdmin } from "../HeaderAdmin";
import { GlobalContainer } from "../../AtomicDesign/Atoms";

export function AdminLayout() {
  const { getUserLocalStorage } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    window?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    const data = getUserLocalStorage();
    if (data?.user && data?.token) {
      if (data?.user?.user?.role && data?.user?.user?.role === "admin") {
        const getLocalTab = localStorage.getItem("@treasure_box_admintab");
        if (getLocalTab) {
          const rout = {
            0: "/admin/users",
            1: "/admin/products",
            2: "/admin/orders",
            3: "/admin/messages",
            4: "/admin/config",
          };
          const routSelect = Number(JSON.parse(getLocalTab));
          navigate(rout[routSelect as keyof typeof rout]);
        }
      } else {
        navigate("/user/my-info");
      }
    } else {
      navigate("/user/login");
    }
    //eslint-disable-next-line
  }, []);

  return (
    <Box
      minWidth={"100%"}
      minHeight={"100vh"}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
    >
      <Box sx={{ width: "100%" }}>
        <HeaderAdmin />
      </Box>

      <Box sx={{ width: "100%" }}>
        <GlobalContainer sx={{ mt: 2, mb: 2 }}>
          <img
            src={Nuvens}
            alt="imagem de nuvens rodape"
            width={"100%"}
            style={{ zIndex: -1, marginBottom: "-18%" }}
          />
          <ContactInfo />
          <Typography textAlign={"center"} mt={10}>
            {String(new Date().getFullYear())} © Coelho Mágico
          </Typography>
        </GlobalContainer>
      </Box>
    </Box>
  );
}
